module.exports = __webpack_public_path__ + "media/src/images/favicon-16x16-e6b6e88dd3eec259f56fc1f3c0f70157.png";